import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Heading1Text,
  Heading2Text,
  Heading3Text,
  ParagraphLargeText,
  TitleMedium,
} from '../../../../components/Texts';
import Line from '../../../../components/Line';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import WidthContainer from '../../../../components/WidthContainer';
import ColorizedSpan from '../../../../components/Colorized';
import { selectThemeMode } from '../../../../redux/slices/themeSlice';
import { useSelector } from 'react-redux';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 25px;
  margin-bottom: 20px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  padding-bottom: 50px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-top: 25px;
    padding-bottom: 25px;
    flex-direction: column;
    width: 95%;
  }
`;

const SecondContainer = styled(InnerContainer)``;

const StyledParagraphLargeText = styled(ParagraphLargeText)`
  font-weight: 400;
`;

const Image = styled.img`
  width: 450px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 90%;
  }
`;

const HowItWorks = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themeMode = useSelector(selectThemeMode);
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const [searchParams] = useSearchParams();
  const lpd = searchParams.get('lpd');
  const isPayments = lpd === 'payments';
  const isYield = lpd === 'yield';

  const getHeading = () => {
    if (isPayments) return <>{t('landing.howItWorks.headingPayments')}</>;
    if (isYield) return <>{t('landing.howItWorks.headingYield')}</>;
    return <>{t('landing.howItWorks.headingDefault')}</>;
  };

  return (
    <>
      <Container>
        <InnerContainer>
          <TitleMedium
            style={{
              color: theme.text.secondary,
              width: '100%',
              textAlign: isMobile ? 'center' : 'left',
              marginBottom: 8,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontSize: 14,
            }}
          >
            {t('landing.howItWorks.sectionTitle')}
          </TitleMedium>
          <Heading3Text
            style={{
              color: theme.text.title,
              width: '100%',
              textAlign: isMobile ? 'center' : 'left',
            }}
          >
            {getHeading()}
          </Heading3Text>
          <Image src='/landing-v2/anniversary-test.webp' />
        </InnerContainer>
        <SecondContainer>
          <div>
            <Line />
            {isPayments ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step1TitlePayments')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step1DescPayments')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step2TitlePayments')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step2DescPayments')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step3TitlePayments')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step3DescPayments')}
                  </StyledParagraphLargeText>
                </div>
              </>
            ) : isYield ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step1TitleYield')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step1DescYield')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step2TitleYield')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step2DescYield')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step3TitleYield')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step3DescYield')}
                  </StyledParagraphLargeText>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    1
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step1TitleDefault')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step1DescDefault')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    2
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step2TitleDefault')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step2DescDefault')}
                  </StyledParagraphLargeText>
                </div>
                <Line />
                <div
                  style={{
                    display: 'flex',
                    gap: 40,
                    padding: '30px 0px',
                    alignItems: 'center',
                  }}
                >
                  <Heading1Text style={{ color: theme.primary.primary }}>
                    3
                  </Heading1Text>
                  <StyledParagraphLargeText>
                    <span style={{ color: theme.text.title }}>
                      <b>{t('landing.howItWorks.step3TitleDefault')}</b>
                    </span>{' '}
                    {t('landing.howItWorks.step3DescDefault')}
                  </StyledParagraphLargeText>
                </div>
              </>
            )}
            <Line />
          </div>
        </SecondContainer>
      </Container>
    </>
  );
};

export default HowItWorks;
